export default "__VITE_ASSET__DYgL0N6O__"